// import HTTPClient from '@common/network/HTTPClient';
// import Tool from '@common/util/Tool';

import axios from 'axios';

function unique(items, fn = null) {
  if (fn) {
    const temp = new Map();
    items.forEach((x, i) => {
      temp.set(fn(x), i);
    });
    return Array.from(temp.values()).map((i) => items[i]);
  } else {
    return Array.from(new Set(items));
  }
}

const process = (data) => {
  const result = {
    langs: {},
    version: '0',
  };

  let keywords = data.keywords;
  let items = data.items;
  let tags = data.tags;
  let version = data.revision;
  let LangNameMap = {};

  data.lang.forEach(function (x) {
    LangNameMap[x] = x;
  });

  let tagData = {};

  tags.forEach(function (x) {
    let tagId = x[0];
    let lang = x[1];
    // let word = x[2];
    let items = x[3];

    tagData[tagId] = {
      lang: lang,
      itemIds: items.map(function (item) {
        return item[0];
      }),
    };
  });

  let itemData = {};
  items.forEach(function (x) {
    let itemId = x[0];
    let type = x[1];
    let detail = x[2];

    itemData[itemId] = {
      type: type,
      detail: detail,
    };
  });

  keywords.forEach(function (x) {
    // let keywordId = x[0];
    let lang = LangNameMap[x[1]];
    let word = x[2];
    let tagIds = x[3];

    if (!result.langs[lang]) {
      result.langs[lang] = {};
    }

    let itemIds = unique(
      Array.prototype.concat.apply(
        [],
        tagIds
          .filter(function (id) {
            return tagData[id];
          })
          .map(function (tagId) {
            return tagData[tagId].itemIds;
          }),
      ),
    );

    result.langs[lang][word] = itemIds.map(function (itemId) {
      let item = itemData[itemId];
      item && (item.id = itemId);
      return item;
    });
  });

  result.version = version;
  return result;
};

const APIUrl = '/sticker/suggestion';

export default class SyncService {
  static async sync() {
    const resp = await axios.get(APIUrl);
    if (resp.status == 200 && resp.data && resp.data.code !== -1) {
      const data = resp.data;
      return process(data);
    } else {
      return new Error('ss.sync');
    }
  }
}
